import React from "react";

export default function FormData(data) {
  return (
    <div>
      <div
        className="row ps-3 ps-lg-4 pe-3 pe-lg-4 pb-1"
        style={{ paddingTop: "24px" }}
      >
        <div className="col-xl-3 col-lg-4 mb-3">
          <p className="form-label">
            Confirm Job Details
          </p>
          <span className="review-text sub-text">
            Please confirm your job details. Use the Back button to edit inputs,
            or Continue to confirm and run iSort&trade;.
          </span>
        </div>
        <div className="col-xl-6 col-lg-8">
          {data.data.formType === "fractionMyData" && (
            <>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Signature Matrix File*
              </label>
              <p>{data.data.signatureMatrixFile}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Bulk Expression File*
              </label>
              <p>{data.data.bulkExpressionFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Platform
              </label>
              <p>{(data.data.platform === "none"? "RNA-Seq" : "Microarray")}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Sequence Type
              </label>
              <p>{data.data.sequenceType}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Token*
              </label>
              <p style={{ wordBreak: "break-word" }}>{data.data.token.value}</p>
              {data.data.runName && (
                <>
                  <label
                    className="menu-options"
                    style={{ paddingBottom: "8px" }}
                  >
                    Run Name
                  </label>
                  <p>{data.data.runName}</p>
                </>
              )}
            </>
          )}
          {data.data.formType === "fractionDemoData" && (
            <>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Bulk Expression File*
              </label>
              <p>{data.data.bulkExpressionFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Token*
              </label>
              <p style={{ wordBreak: "break-word" }}>{data.data.token.value}</p>
              {data.data.runName && (
                <>
                  <label
                    className="menu-options"
                    style={{ paddingBottom: "8px" }}
                  >
                    Run Name
                  </label>
                  <p>{data.data.runName}</p>
                </>
              )}
            </>
          )}
          {data.data.formType === "hiresMyData" && (
            <>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Fraction Result File*
              </label>
              <p>{data.data.fractionResultFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Mixture File*
              </label>
              <p>{data.data.bulkExpressionFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Platform
              </label>
              <p>{data.data.platform}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Token*
              </label>
              <p style={{ wordBreak: "break-word" }}>
                {" "}
                {data.data.token.value}
              </p>
              {data.data.runName && (
                <>
                  <label
                    className="menu-options"
                    style={{ paddingBottom: "8px" }}
                  >
                    Run Name
                  </label>
                  <p>{data.data.runName}</p>
                </>
              )}
            </>
          )}
          {data.data.formType === "hiresDemoData" && (
            <>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Mixture File*
              </label>
              <p>{data.data.bulkExpressionFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Fraction File*
              </label>
              <p>{data.data.fractionResultFile.value}</p>
              <label className="menu-options" style={{ paddingBottom: "8px" }}>
                Token*
              </label>
              <p style={{ wordBreak: "break-word" }}>{data.data.token.value}</p>
              {data.data.runName && (
                <>
                  <label
                    className="menu-options"
                    style={{ paddingBottom: "8px" }}
                  >
                    Run Name
                  </label>
                  <p>{data.data.runName}</p>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
